import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { AutoGallery } from './components/AutoGallery';
import { Motivations } from './components/Motivations';
import { HowItWorks } from './components/HowItWorks';
import { CreationsGallery } from './components/CreationsGallery';
import { MainGuide } from './components/MainGuide';
import { Bonuses } from './components/Bonuses';
import { TemplateLibrary } from './components/TemplateLibrary';
import { Testimonials } from './components/Testimonials';
import { Offer } from './components/Offer';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { originalGallery } from './data/galleries';
import { siteConfig } from './data/siteConfig';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel(siteConfig.metaPixelId);
  useEffect(() => {
    document.title = `${siteConfig.brandName} — Le pack créatif`;
    document.documentElement.lang = 'fr';
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3mjgczu7zmpqf">
      <div className="min-h-screen w-full [overflow-x:clip] bg-ivory font-sans text-ink selection:bg-coral-deep selection:text-white" data-id="element-1" data-mp="3rbzn2h7gv2qh">
        <AnnouncementBar data-id="element-2" data-mp="5ggxfcks0yi" />
        <Header data-id="element-3" data-mp="7st1bvnjh3n" />
        <main id="contenu" data-id="element-4" data-mp="2zld2xbxu5jcl">
          <Hero data-id="element-5" data-mp="2zm4wkh7vh708" />
          <AutoGallery items={originalGallery} label="Exemples de décorations en faux vitrail" data-id="element-6" data-mp="2zmo4d53t6f0j" />
          <Motivations data-id="element-7" data-mp="33n6zb810016y" />
          <HowItWorks data-id="element-8" data-mp="33ork45xig5rm" />
          <CreationsGallery data-id="element-9" data-mp="38m1gy6n8bjph" />
          <MainGuide data-id="element-10" data-mp="38kqce4lym7xb" />
          <Bonuses data-id="element-11" data-mp="38k6wetfvdtlx" />
          <TemplateLibrary data-id="element-12" data-mp="38num1hi71vvd" />
          <Testimonials data-id="element-13" data-mp="3dkl0y1i9ilf7" />
          <AutoGallery items={originalGallery} label="Autres idées de décorations en faux vitrail" data-id="element-14" data-mp="3dlw4q1bpjt6b" />
          <Offer data-id="element-15" data-mp="nuhj4kutefvc" />
          <FAQ data-id="element-16" data-mp="nv1284w7baay" />
        </main>
        <Footer data-id="element-17" data-mp="suncc5gqgafj" />
      </div>
    </MotionConfig>;
}